import { render, staticRenderFns } from "./problemStatistics.vue?vue&type=template&id=3ac1ffcd&scoped=true"
import script from "./problemStatistics.vue?vue&type=script&lang=js"
export * from "./problemStatistics.vue?vue&type=script&lang=js"
import style0 from "./problemStatistics.vue?vue&type=style&index=0&id=3ac1ffcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac1ffcd",
  null
  
)

export default component.exports